module.exports = __webpack_public_path__ + "static/media/Chirs.bd61a7e7.png";